export const updateObject = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};

export const toTime = nr => {
    if (nr === '-:-') return nr;
    else { var n = ' ' + nr / 1000 + ' '; return n.substr(0, n.length - 1) + 's'; }
};